import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { FormMoneyInput } from '../form/FormMoneyInput';
import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';

export interface Check {
  amount: number;
  checkNumber: string;
}
interface CheckDialogProps {
  isOpen: boolean;
  onSave: (saved: Check) => void;
  onCancel: () => void;
  error?: string;
  title?: string;
  saveLabel?: string;
}
class CheckValues {
  amount = '';
  checkNumber = '';
}

export class CheckDialog extends React.Component<CheckDialogProps> {
  validationSchema = Yup.object().shape({
    amount: Yup.number().required('Required'),
    checkNumber: Yup.string().required('Required'),
  });

  initialValues() {
    return {
      amount: '',
      checkNumber: '',
    };
  }

  handleSubmit = (values: CheckValues) => {
    this.props.onSave({
      amount: Number(values.amount),
      checkNumber: values.checkNumber,
    });
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<CheckValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>
                {this.props.title ? this.props.title : 'Process Check'}
              </ModalHeader>
              <ModalBody>
                <FormMoneyInput label="Check Amount" name="amount" id="amount" />
                <FormInput label="Check Number" name="checkNumber" id="checkNumber" />
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    {this.props.saveLabel ? this.props.saveLabel : 'Save'}
                  </Button>
                </div>
              </ModalFooter>
              {this.props.error && <div className="alert alert-danger">{this.props.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/CheckDialog.tsx